import { apiClient, post } from "@/_nucleo/api"
import { useMutation } from "@tanstack/react-query"
import { AprovarFaturaBody } from "./_types"

type AprovarResponse = {
  Sucesso: boolean
  Mensagem: string
}

const BASE_PATH = "rpws003/gerafatura"

async function aprovarFaturaApi(
  REC: string,
  usr: string,
  body: AprovarFaturaBody
): Promise<AprovarResponse> {
  const { data } = await post(apiClient.production, `${BASE_PATH}?REC=${REC}&usr=${usr}`, body)
  return data as AprovarResponse
}

export function useFinanceiroAprovarFaturasMutation(REC: string, usr: string) {
  return useMutation<AprovarResponse, Error, AprovarFaturaBody>({
    mutationFn: (body) => aprovarFaturaApi(REC, usr, body),
  })
}
